var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-skeleton-square-wrap"},_vm._l((_vm.count),function(i){return _c('div',{key:i,staticClass:"vue-skeleton-square",style:({
      backgroundColor: _vm.backColor,
      width: _vm.width,
      height: _vm.height,
      margin: _vm.margin
    })})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }